import React from 'react';
import Account from "./Account";
import {withRouter} from "./withRouter";
import {Button, Card, Col, Container, Form, Row} from "react-bootstrap";

class Contacts extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        return <div>
                <main role="main">
                    <div className="jumbotron" style={{
                        backgroundColor: "#CECECE",
                        padding: "5%",
                        marginBottom: 20,
                    }}>
                        <div className="container">
                            <h1 className="display-3">Easy Street: Your Gateway to App Harmony</h1>
                            <p id="main" style={{
                                display: "block"
                            }}>
                                Easy Street is a revolutionary platform that seamlessly bridges the gap between
                                users and their desired app versions, providing platform-independent access
                                with unparalleled ease.
                                <br/>
                                <p><a className="btn btn-primary btn-lg" href="#" role="button" onClick={(e) => {
                                    let mainBlock = document.getElementById('main');
                                    let extraBlock = document.getElementById('extra');

                                    if (mainBlock.style.display === 'none') {
                                        mainBlock.style.display = 'block';
                                        extraBlock.style.display = 'none';
                                    } else {
                                        mainBlock.style.display = 'none';
                                        extraBlock.style.display = 'block';
                                    }
                                }}>More »</a></p>
                            </p>
                            <p id="extra" style={{
                                display: "none"
                            }}>In a digital world bursting with a multitude of app publishers, Easy Street is your one-stop destination for accessing the app versions you need, regardless of your device or operating system.
                                Whether you're searching for productivity tools, entertainment apps, or specialized software, Easy Street has you covered.
                                But Easy Street isn't just for app users; it's also a welcoming home for developers. We invite developers from all walks of life to join our platform, empowering them to share their creations with a global audience. Whether you're a seasoned developer or just starting out, you can become a valued member of the Easy Street community, reaching users who are eager to explore innovative applications.
                                Easy Street's mission is simple: to democratize app access and foster a vibrant ecosystem where users and developers thrive in perfect harmony. Experience the future of app exploration and collaboration with Easy Street today.
                                <br/>
                                <p><a className="btn btn-primary btn-lg" href="#" role="button" onClick={(e) => {
                                    let mainBlock = document.getElementById('main');
                                    let extraBlock = document.getElementById('extra');

                                    if (mainBlock.style.display === 'none') {
                                        mainBlock.style.display = 'block';
                                        extraBlock.style.display = 'none';
                                    } else {
                                        mainBlock.style.display = 'none';
                                        extraBlock.style.display = 'block';
                                    }
                                }}>Less «</a></p>

                            </p>

                        </div>
                    </div>

                    <div className="container">
                        <div className="row">
                            <div className="col-md-4">
                                <h2>Vertex Studio</h2>
                                <p>The owners of ES platform.<br/> ES first release was in May, 2023.</p>
                                <p><a className="btn btn-secondary" href="https://vertexstudio.herokuapp.com/" role="button">View details »</a></p>
                            </div>
                            <div className="col-md-4">
                                <h2>Contacts & Support</h2>
                                <p>In case if you have any questions or if you need help with your apps publishing.</p>
                                <p><a className="btn btn-secondary" href="https://vertexstudio.herokuapp.com/contacts" role="button">View details »</a></p>
                            </div>
                        </div>

                        <hr/>

                    </div>

                </main>
        </div>
    }
}

export default withRouter(Contacts);
